const mod = require('../../bahabot.module.js')
mod.directive(
    'ngContextmenu',
    [
        '$parse', 
        function($parse) {
            return function(scope, element, attrs) {
                const fn = $parse(attrs.ngContextmenu);
                
                element.bind('contextmenu', function(event) {
                    scope.$apply(function() {
                        event.preventDefault();
                        fn(scope, { $event:event });
                    });
                });
            };
        }
    ]
);